import React, { useState, useEffect } from 'react';

const TasaDeCambio = () => {
    const [exchangeRate, setExchangeRate] = useState(4000);
    const [savedMessage, setSavedMessage] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem('usdExchangeRate');
        if (saved) {
            setExchangeRate(parseFloat(saved));
        }
    }, []);

    const handleSave = () => {
        if (exchangeRate > 0) {
            localStorage.setItem('usdExchangeRate', exchangeRate);
            setSavedMessage(true);
            setTimeout(() => setSavedMessage(false), 3000);
        }
    };

    return (
        <div style={{ padding: '2rem', maxWidth: '500px', margin: '0 auto' }}>
            <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem' }}>Configuración de Tasa de Cambio</h2>
            
            <div style={{
                backgroundColor: '#ffffff',
                padding: '2rem',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
                border: '1px solid #e6dfd3'
            }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#4a3f36' }}>
                    Tasa de Cambio Actual (COP por USD)
                </label>
                
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1rem' }}>
                    <div style={{ position: 'relative', flex: 1 }}>
                        <span style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#8a7d70' }}>$</span>
                        <input
                            type="number"
                            value={exchangeRate}
                            onChange={(e) => setExchangeRate(parseFloat(e.target.value) || '')}
                            style={{
                                width: '100%',
                                padding: '0.75rem 0.75rem 0.75rem 2rem',
                                border: '2px solid #d6ccbc',
                                borderRadius: '8px',
                                fontSize: '1.125rem',
                                outline: 'none'
                            }}
                        />
                    </div>
                    <button
                        onClick={handleSave}
                        style={{
                            padding: '0.75rem 1.5rem',
                            backgroundColor: 'var(--primary-color)',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            transition: 'background-color 0.2s'
                        }}
                    >
                        Guardar
                    </button>
                </div>
                
                {savedMessage && (
                    <div style={{ color: '#5f8a5e', fontWeight: '600', fontSize: '0.875rem' }}>
                        <i className="bi bi-check-circle-fill" style={{ marginRight: '0.5rem' }}></i>
                        Tasa de cambio guardada correctamente.
                    </div>
                )}
                
                <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f4efe6', borderRadius: '8px', fontSize: '0.875rem', color: '#6b5e51' }}>
                    <strong>Nota:</strong> Este valor se utilizará en el Punto de Venta para calcular los equivalentes de pagos en dólares, así como para los vueltos en pagos mixtos.
                </div>
            </div>
        </div>
    );
};

export default TasaDeCambio;
